module.exports = __webpack_public_path__ + "media/images/markers/circle_flag_marker-dc3b5fdde209d7f8fa2a0e273d478604.svg";